import type { MessageSchema } from '.';

const messages: MessageSchema = {
	selected_reservation_date: 'Geselecteerde reserveringsdatum',
	change_date: 'Datum wijzigen',
	reserve_with_voucher: 'Reserveer met voucher(code)',
	redeem_your_vouchers_here: 'Verzilver hier je vouchers!',
	redeem_your_vouchers_and_gift_vouchers_during_payment_step:
		'Vul hieronder je unieke vouchercode(s) in. Cadeaubonnen kun je inwisselen tijdens het afrekenen.',
	cancel: 'Annuleren',
	redeem: 'Verzilveren',
	voucher_code: 'Voucher Code',
	from: 'Vanaf',
	per_person_short: 'p.p.',
	starting_from_short: 'v.a.',
	unable_to_redeem_voucher: 'Het is niet gelukt je voucher in te wisselen',
	view: 'Bekijken',
	book: 'Reserveren',
	ok: 'OK',
	more_info: 'Meer info',
	swimwear_day: 'Badkledingdag',
	filter_swimwear_days: 'Filter op badkledingdagen',
	add_extra_voucher: 'Extra voucher toevoegen',
	make_your_choice: 'Maak jouw keuze',
	choose_from_options: 'Je kunt kiezen uit {count} opties',
	unavailable_in_active_locale_message: 'Let op: u wordt doorgestuurd naar onze Engelstalige website.',
	loading: 'Laden',
	reserve_with_bathcard: 'Reserveer met badenkaart',
	i_have_a_gift_voucher: 'Ik heb een cadeaubon',
	back: 'Terug',
	close: 'Sluiten',
	more_information: 'Meer informatie',
	view_page: 'Bekijk pagina',
	choose: 'Kies',
	go_back: 'Ga terug',
	previous_option: 'Vorige optie',
	next_option: 'Volgende optie',
	arrangements_and_deals: 'Arrangementen & deals',
	choose_date: 'Kies datum',
	clear_date: 'Verwijder gekozen datum',
	choose_arrival_date: 'Kies aankomstdatum',
	prices_per_person: 'Prijzen zijn per persoon',
	prices_per_person_per_night: 'Prijzen zijn per persoon per nacht',
	availability_notice: 'Er is nog beschikbaarheid!',
};

export default messages;
